//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

import _ from "js/underscore-mixins";

(function() {
    /**  Merges N objects together with each right-hand object's properties overriding the left. */
  const merge = function(...args) {
    const objects = [].slice.call(args, 0); // varargs...
    const extendArguments = [true, {}].concat(objects);
    return $.extend.apply(this, extendArguments);
  };

  angular.module('curalate').directive('areaChart', ['CHART_COLORS', function(CHART_COLORS) {
    const AREA_CHART_DISPLAY_OPTIONS = {
      size: {
        height: 260,
        width: null,
      },
      options: {
        chart: {
          type: 'area',
          backgroundColor: CHART_COLORS['@marshmallow'],
          borderColor: CHART_COLORS['@mushroom'],
          borderWidth: 1,
          borderRadius: 3,
          spacing: [20, 35, 20, 15],
          zoomType: 'xy', // Enables click-and-drag zooming
          animation: true, // Enables animations when chart axes change (the initial animation is handled by a different setting)
          resetZoomButton: {
            theme: {
              stroke: '#CCC',
              fill: 'white',
              style: {
                color: CHART_COLORS['@oyster'],
                letterSpacing: '0',
                fontWeight: '400',
              },
              states: {
                hover: {
                  fill: CHART_COLORS['@mushroom'],
                  stroke: '#CCC',
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        title: null,
        loading: true,
        subtitle: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          tickLength: 5, // Ticks below x-axis
          tickColor: CHART_COLORS['@guacamole'],
          lineColor: CHART_COLORS['@guacamole'],
          minorGridLineColor: CHART_COLORS['@mushroom'],
          gridLineWidth: 1, // Vertical grid lines
          gridLineColor: CHART_COLORS['@mushroom'],
          labels: {
            useHTML: false,
            style: {
              fontSize: '13px',
              color: CHART_COLORS['@oreo'],
              paddingTop: '10px',
              whiteSpace: 'nowrap',
            },
            formatter() { return ''; },
          },
          events: {
            setExtremes(e) { // triggered on zoom
              if (!e.min && !e.max) {
                                // the chart is zoomed out
                this.options.labels.enabled = true;
              } else {
                this.options.labels.enabled = false;
              }
            },
          },
        },
        yAxis: {
          gridLineColor: CHART_COLORS['@mushroom'],
          tickLength: 5, // Length of ticks appearing to the left of y-axis
          allowDecimals: false, // Only allow integers on y-axis labels
          title: {
            text: null,
            enabled: false,
          },
          showFirstLabel: false, // Don't show first y-axis label
        },
        plotOptions: {
          area: {
            fillOpacity: 0.25, // Opacity of area under plot lines
            shadow: false,
          },
          line: {
            shadow: false,
          },
          series: {
            marker: { // Styling for each point in the series
              enabled: true,
              symbol: 'circle',
            },
            threshold: 0, // Allows the graph to show filled-in area below zero - we need this since negative numbers are valid in some graphs
          },
        },
      },
    };

    return {
      scope: {
        chartTitle: '@',
        data: '=',
        page: '@',
        titleSize: '@',
        customOptions: '=',
        customHeight: '<?',
        customWidth: '<?',
      },
      restrict: 'E',
      template: '<highchart id="id" config="config"></highchart>',
      controller: ['$scope',
        function($scope) {
          const MAX_DATA_LABELS = 15;
          const initialMergedOptions = merge(
            AREA_CHART_DISPLAY_OPTIONS,
            { options: $scope.customOptions },
            {
              size: {
                height: $scope.customHeight || _($scope.config).safeGet('size.height'),
                width: $scope.customWidth || null,
              },
            },
          );

          if ((_($scope.data).safeGet('categories') || []).length > MAX_DATA_LABELS) {
            // Hide data labels regardless of the setting if we have > 15 data points
            $scope.config = merge(
              initialMergedOptions,
              {
                options: {
                  plotOptions: {
                    area: {
                      dataLabels: {
                        enabled: false,
                      },
                    },
                  },
                },
              });
          } else {
            $scope.config = initialMergedOptions;
          }

          const buildChart = function(categories, series, seriesLabel, axisFormatter) {
            let pointRadius;

            if (!categories || !series || !seriesLabel) {
              return null;
            }

                        // The tick interval is increased by 1 for every "n" days in the date range
            const interval = (categories.length > 20) ? Math.round(categories.length / 20) : 1;

                        // Size of the point depends upon the number of days in the date range - the radius decreases as the x-axis gets bigger.
            if (categories.length > 120) {
              pointRadius = 1;
            } else if (categories.length > 90) {
              pointRadius = 2;
            } else if (categories.length > 60) {
              pointRadius = 3;
            } else {
              pointRadius = 4;
            }

                        // For x-axis labels: only display the first date and last date in the series
            function displayFirstAndLastDates() {
              const labelsEnabled = this.axis.options.labels.enabled;
              if (this.isFirst && labelsEnabled) {
                return axisFormatter ? axisFormatter(categories[0]) : categories[0];
              } else if (this.isLast && labelsEnabled) {
                return axisFormatter ? axisFormatter(categories[categories.length - 1]) : categories[categories.length - 1];
              }
              return null;
            }

            const tooltipFormatter = function() {
              return `<strong>${this.x}</strong><br/>${
                                 this.point.series.name}: ${CURALATE.misc.renderToReadableNumber(null, this.point.y)}`;
            };

            const optionsWithData = {
              options: {
                xAxis: {
                  categories,
                  tickInterval: interval,
                  labels: {
                    formatter: displayFirstAndLastDates,
                  },
                  tickColor: CHART_COLORS['@mushroom'],
                  lineColor: CHART_COLORS['@mushroom'],
                },
                plotOptions: {
                  area: {
                    marker: {
                      radius: pointRadius,
                    },
                  },
                },
                tooltip: {
                  formatter: tooltipFormatter,
                },
              },
              series: [{
                name: seriesLabel,
                data: series,
                color: CHART_COLORS['@guacamole'],
              }],
            };

            const allZeros = _(series).every((value) => { return value === 0; });

            if (allZeros) {
                            // Manually set the maximum to 1 for data that is all zeros. Otherwise, Highcharts will
                            // set the max and min to 0. If there is a value in "series" that is > 0, Highcharts will set a correct max value
              optionsWithData.options.yAxis = {
                min: 0,
                max: 1,
              };
            }

            const mergedOptions = merge(
              AREA_CHART_DISPLAY_OPTIONS,
              optionsWithData,
              { options: $scope.customOptions },
              {
                size: {
                  height: $scope.customHeight || _($scope.config).safeGet('size.height'),
                  width: $scope.customWidth || null,
                },
              },
            );

            if (categories.length > MAX_DATA_LABELS) {
              // Hide data labels regardless of the setting if we have > 15 data points
              return merge(
                mergedOptions,
                {
                  options: {
                    plotOptions: {
                      area: {
                        dataLabels: {
                          enabled: false,
                        },
                      },
                    },
                  },
                });
            } else {
              return mergedOptions;
            }
          };

                    // Update the chart whenever chart data changes
          $scope.$watch('data', (newData) => {
            if (_.isEmpty(newData)) {
              return;
            }

            const categories = newData.categories;
            const series = newData.series;
            const label = newData.label;
            const axisFormatter = newData.axisFormatter;

            $scope.config = buildChart(categories, series, label, axisFormatter);
          });
        },
      ],
    };
  }]);
})();
